<script lang="ts">
	import type { HTMLAttributes } from "svelte/elements";

	const { icon, ...props }: { icon: string } & HTMLAttributes<HTMLDivElement> = $props();

	/* eslint-disable svelte/no-at-html-tags */
</script>

<!-- Setting min and max width/height because Safari 16 is a bad boy and refuses to work properly when setting width/height -->
<div
	{...props}
	class={[
		props.class,
		"shrink-0 [&>svg]:max-h-full [&>svg]:min-h-full [&>svg]:min-w-full [&>svg]:max-w-full flex justify-center items-center",
	]}
>
	{@html icon}
</div>
